var _circle, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.75,
    cy: 13.0625,
    r: 12.375,
    fill: "url(#paint0_radial_52_453)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44393 15.4792C8.52654 15.4002 8.63854 15.3559 8.75531 15.3559H19.5293C19.7256 15.3559 19.8238 15.583 19.685 15.7158L17.5561 17.7516C17.4735 17.8306 17.3615 17.875 17.2447 17.875H6.47069C6.27444 17.875 6.17618 17.6479 6.315 17.5151L8.44393 15.4792Z",
    fill: "url(#paint1_linear_52_453)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44393 7.87338C8.52653 7.79437 8.63853 7.75 8.75531 7.75H19.5293C19.7256 7.75 19.8238 7.97714 19.685 8.10993L17.5561 10.1458C17.4735 10.2248 17.3615 10.2691 17.2447 10.2691H6.47069C6.27444 10.2691 6.17618 10.042 6.315 9.90923L8.44393 7.87338Z",
    fill: "url(#paint2_linear_52_453)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5561 11.6521C17.4735 11.5731 17.3615 11.5287 17.2447 11.5287H6.47069C6.27444 11.5287 6.17618 11.7559 6.315 11.8886L8.44393 13.9245C8.52653 14.0035 8.63853 14.0479 8.75531 14.0479H19.5293C19.7256 14.0479 19.8238 13.8207 19.685 13.6879L17.5561 11.6521Z",
    fill: "url(#paint3_linear_52_453)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_52_453",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.38235 8.60386) rotate(56.0702) scale(18.095)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564858,
    stopColor: "#ADA4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584C85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_52_453",
    x1: 15.3768,
    y1: 4.97267,
    x2: 8.42181,
    y2: 18.8921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#897DC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7567B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_52_453",
    x1: 15.3768,
    y1: 4.97267,
    x2: 8.42181,
    y2: 18.8921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#897DC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7567B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_52_453",
    x1: 15.3768,
    y1: 4.97267,
    x2: 8.42181,
    y2: 18.8921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#897DC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7567B9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.71de500ef6ed73180672d3ce9136ff25.svg";
export { ForwardRef as ReactComponent };